/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * BASELINE. Do not copy and paste
 *	> 'createAccessors' import from 'owa-viewstate-store' is restricted. createAccessors can cause performance problems. Create mutators by hand */
import { createAccessors } from "owa-viewstate-store";
import { createStore } from "owa-satcheljs";

const ALL_BUILDINGS_OPTION = "all-buildings";

const dest = createAccessors("hybridspace-location-view-filter", createStore("hybridspace-location-view-filter", {
    filterTextValue: "",
    filterOptions: [ALL_BUILDINGS_OPTION],
    showBuildingFilterOptions: undefined as boolean | undefined,
}));
const setFilterTextValue: (newValue: string) => void = dest.setFilterTextValue;
const getFilterTextValue: () => string = dest.getFilterTextValue;
const setFilterOptions: (newValue: string[]) => void = dest.setFilterOptions;
const getFilterOptions: () => string[] = dest.getFilterOptions;
const getShowBuildingFilterOptions: () => boolean | undefined = dest.getShowBuildingFilterOptions;
const setShowBuildingFilterOptions: (newValue: boolean | undefined) => void = dest.setShowBuildingFilterOptions;

export { setFilterTextValue, getFilterTextValue, setFilterOptions, getFilterOptions, ALL_BUILDINGS_OPTION, getShowBuildingFilterOptions, setShowBuildingFilterOptions, };
